var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprovalWorkflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2621_10179)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 31,
    fill: "#00C67F",
    fillOpacity: 0.11
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2621_10179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2587 51.2857H56.7765V46.1964C56.7765 46.0491 56.656 45.9286 56.5087 45.9286H48.2051V42.7143H51.8212C52.1158 42.7143 52.3569 42.4732 52.3569 42.1786V32.5357C52.3569 32.2411 52.1158 32 51.8212 32H42.1783C41.8836 32 41.6426 32.2411 41.6426 32.5357V42.1786C41.6426 42.4732 41.8836 42.7143 42.1783 42.7143H45.7944V45.9286H37.4908C37.3435 45.9286 37.2229 46.0491 37.2229 46.1964V51.2857H33.7408C33.4461 51.2857 33.2051 51.5268 33.2051 51.8214V61.4643C33.2051 61.7589 33.4461 62 33.7408 62H43.3837C43.6783 62 43.9194 61.7589 43.9194 61.4643V51.8214C43.9194 51.5268 43.6783 51.2857 43.3837 51.2857H39.6336V48.3393H54.3658V51.2857H50.6158C50.3212 51.2857 50.0801 51.5268 50.0801 51.8214V61.4643C50.0801 61.7589 50.3212 62 50.6158 62H60.2587C60.5533 62 60.7944 61.7589 60.7944 61.4643V51.8214C60.7944 51.5268 60.5533 51.2857 60.2587 51.2857ZM41.3747 53.8304V59.4554H35.7497V53.8304H41.3747ZM44.1872 40.1696V34.5446H49.8122V40.1696H44.1872ZM58.2497 59.4554H52.6247V53.8304H58.2497V59.4554Z",
    fill: "#20435D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2621_10179",
    x: 0,
    y: 0,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_2621_10179"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2621_10179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(32 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalWorkflow);
export default __webpack_public_path__ + "static/media/approval-workflow.f6fd4ed097d04cff0d86f13f0b44cc32.svg";
export { ForwardRef as ReactComponent };